/** Öffnungs-State der Bulk-Dialoge (Verschieben/Kategorie ändern/Löschen) — hält je die Auswahl. */
import { useState } from 'react';
import type { PropertyDocumentKind, PropertyFileResponse } from '@/shared/api';

/** Bulk-Aktions-Auslöser für die Selektions-Toolbar (Auswahl → Dialog/Op). */
export interface AkteBulkHandlers {
  onMove: (files: PropertyFileResponse[]) => void;
  onReclassify: (files: PropertyFileResponse[]) => void;
  onDelete: (files: PropertyFileResponse[]) => void;
  onDownload: (files: PropertyFileResponse[]) => void;
}

export function useAkteBulkDialogs() {
  const [moveFiles, setMoveFiles] = useState<PropertyFileResponse[] | null>(null);
  const [reclassifyFiles, setReclassifyFiles] = useState<PropertyFileResponse[] | null>(null);
  // Vorbelegtes Ziel-Kind beim Cross-Category-Drop einer Auswahl (sonst = Kind der ersten Datei).
  const [reclassifyKind, setReclassifyKind] = useState<PropertyDocumentKind | null>(null);
  const [deleteFiles, setDeleteFiles] = useState<PropertyFileResponse[] | null>(null);

  return {
    moveFiles,
    reclassifyFiles,
    reclassifyKind,
    deleteFiles,
    openMove: setMoveFiles,
    openReclassify: (
      files: PropertyFileResponse[],
      suggestedKind?: PropertyDocumentKind | null,
    ) => {
      setReclassifyKind(suggestedKind ?? null);
      setReclassifyFiles(files);
    },
    openDelete: setDeleteFiles,
    closeMove: () => setMoveFiles(null),
    closeReclassify: () => {
      setReclassifyFiles(null);
      setReclassifyKind(null);
    },
    closeDelete: () => setDeleteFiles(null),
  };
}
